module.exports = __webpack_public_path__ + "static/media/arrowdownselect.9631499c.svg";